import { Box } from '@mantine/core'
import { useI18n } from '../../_i18n'
import { TILE } from '../_tiles'
import { WeekSection } from '../_week'

// Holds the space a loaded weather band will occupy, for the window between
// hydration and the CDN fetch resolving.
//
// Why this exists: the band is client-fetched, so effects don't run during
// renderToString and the server ships a day card with no weather in it. Without
// a placeholder, seven bands of ~360px each appear at once a few hundred
// milliseconds after load, shoving everything below them down the page. That is
// a layout shift above in-viewport content on the site's most-indexed pages,
// and it would land on Cumulative Layout Shift every single page load.
//
// MarineForecastRail already does this for the card under the map (a
// fixed-height Skeleton); this is the same idea for the per-day bands, which
// were the half that didn't.
//
// The height is the body only — WeekSection draws the header identically in
// both states, so it cancels out. Four rows is the common shape for a coastal
// station (temperature, chances, max seas, visibility); a station with three
// gives back one row's height, which is a far smaller shift than reserving
// nothing at all. Exactness isn't achievable here — row count depends on data
// we don't have yet — but approximate reservation collapses most of the shift.
const ROW_H = 44 // WeekRow: 9px padding twice + a 1.05rem line
const ROWS = 4
const CHART_H = 107 // inset padding + panel + track + axis row
const DISCLOSURE_H = 35 // the HOURLY FORECAST toggle
const BODY_H = ROWS * ROW_H + CHART_H + DISCLOSURE_H

export default function DayWeatherBandSkeleton() {
  const { t } = useI18n()
  return (
    // A neutral glyph rather than the day's condition, which isn't known yet.
    // Same glyph size, so swapping it in when the data lands costs no shift.
    <WeekSection bg={TILE.mid} emoji="🌤️" title={t('weather')}>
      <Box style={{ height: BODY_H, borderTop: '1px solid rgba(255,255,255,.14)' }} />
    </WeekSection>
  )
}
